import { IWorkflowMutations } from './mutations.types';
import {
  IWorkflowData,
  IWorkflowStateData,
  IWorkflowTransitionData,
  IWorkflowStateThresholdData
} from '@/models';
import { IWorkflowStoreState } from '../workflow.types';

export const mutations: IWorkflowMutations = {
  SET_WORKFLOWS(state: IWorkflowStoreState, payload: IWorkflowData[]): void {
    state.workflows = payload;
  },

  ADD_WORKFLOW(state: IWorkflowStoreState, payload: IWorkflowData): void {
    state.workflows.unshift(payload);
  },

  UPDATE_WORKFLOW(state: IWorkflowStoreState, payload: IWorkflowData): void {
    const index = state.workflows.findIndex(
      (workflow: IWorkflowData) => workflow.id === payload.id
    );

    state.workflows.splice(index, 1, payload);
  },

  REMOVE_WORKFLOW(state: IWorkflowStoreState, payload: number): void {
    const index = state.workflows.findIndex(
      (workflow: IWorkflowData) => workflow.id === payload
    );

    state.workflows.splice(index, 1);
  },

  /** #### STATE #### */
  SET_WORKFLOW_STATES(
    state: IWorkflowStoreState,
    payload: IWorkflowStateData[]
  ): void {
    state.states = payload;
  },

  ADD_WORKFLOW_STATE(
    state: IWorkflowStoreState,
    payload: IWorkflowStateData
  ): void {
    state.states.unshift(payload);
  },

  UPDATE_WORKFLOW_STATE(
    state: IWorkflowStoreState,
    payload: IWorkflowStateData
  ): void {
    const index = state.states.findIndex(state => state.id === payload.id);

    state.states.splice(index, 1, payload);
  },

  REMOVE_WORKFLOW_STATE(state: IWorkflowStoreState, payload: number): void {
    const index = state.states.findIndex(state => state.id === payload);

    state.states.splice(index, 1);
  },

  SET_LAST_UPSERTED_WORKFLOW_STATE_ID(
    state: IWorkflowStoreState,
    payload: number
  ): void {
    state.lastUpsertedWorkflowStateId = payload;
  },

  /** #### TRANSITION #### */

  SET_WORKFLOW_TRANSITIONS(
    state: IWorkflowStoreState,
    payload: IWorkflowTransitionData[]
  ): void {
    state.transitions = payload;
  },

  ADD_WORKFLOW_TRANSITION(
    state: IWorkflowStoreState,
    payload: IWorkflowTransitionData
  ): void {
    state.transitions.unshift(payload);
  },

  UPDATE_WORKFLOW_TRANSITION(
    state: IWorkflowStoreState,
    payload: IWorkflowTransitionData
  ): void {
    const index = state.transitions.findIndex(
      transition => transition.id === payload.id
    );

    state.transitions.splice(index, 1, payload);
  },

  REMOVE_WORKFLOW_TRANSITION(
    state: IWorkflowStoreState,
    payload: number
  ): void {
    const index = state.transitions.findIndex(
      transition => transition.id === payload
    );

    state.transitions.splice(index, 1);
  },

  /** #### STATE THRESHOLD #### */
  SET_WORKFLOW_STATE_THRESHOLDS(
    state: IWorkflowStoreState,
    payload: IWorkflowStateThresholdData[]
  ): void {
    state.thresholds = payload;
  },

  UPSERT_WORKFLOW_STATE_THRESHOLD(
    state: IWorkflowStoreState,
    payload: IWorkflowStateThresholdData
  ): void {
    const index = state.thresholds.findIndex(
      threshold => threshold.id === payload.id
    );

    if (index !== -1) {
      state.thresholds.splice(index, 1, payload);
    } else {
      state.thresholds.unshift(payload);
    }
  },

  REMOVE_WORKFLOW_STATE_THRESHOLD(
    state: IWorkflowStoreState,
    payload: number
  ): void {
    const index = state.thresholds.findIndex(
      threshold => threshold.id === payload
    );
    state.thresholds.splice(index, 1);
  }
};
